import React from "react";

type State = {
  scrollWidth: number;
  scrollHeight: number;
  clientWidth: number;
  clientHeight: number;
  scrollLeft: number;
  scrollTop: number;
};

export function useScrollBoxApi(element: HTMLDivElement | null) {
  const [state, setState] = React.useState<State>();

  React.useEffect(() => {
    const refresh = () => {
      const state: State | undefined = element
        ? {
            scrollWidth: element.scrollWidth,
            scrollHeight: element.scrollHeight,
            clientWidth: element.clientWidth,
            clientHeight: element.clientHeight,
            scrollLeft: element.scrollLeft,
            scrollTop: element.scrollTop,
          }
        : undefined;
      setState(state);
    };

    if (!element) return;

    const observer = new ResizeObserver(refresh);
    observer.observe(element);

    element.addEventListener("scroll", refresh);

    return () => {
      observer.unobserve(element);
      element.removeEventListener("scroll", refresh);
    };
  }, [element]);

  const scrollUp =
    element && state && state.scrollTop > 0
      ? (distance: number) => {
          element.scrollTop -= distance;
        }
      : undefined;

  const scrollDown =
    element &&
    state &&
    state.scrollTop < state.scrollHeight - state.clientHeight
      ? (distance: number) => {
          element.scrollTop += distance;
        }
      : undefined;

  const scrollLeft =
    element && state && state.scrollLeft > 0
      ? (distance: number) => {
          element.scrollLeft -= distance;
        }
      : undefined;

  const scrollRight =
    element && state && state.scrollLeft < state.scrollWidth - state.clientWidth
      ? (distance: number) => {
          element.scrollLeft += distance;
        }
      : undefined;

  return state
    ? {
        ...state,
        scrollUp,
        scrollDown,
        scrollLeft,
        scrollRight,
      }
    : undefined;
}
